import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { App } from "./App";
import { AuthProvider } from "./auth/AuthProvider";
import { AppErrorBoundary } from "./components/AppErrorBoundary";
import { UnsavedChangesProvider } from "./components/UnsavedChanges";
import { clearChunkRecovery, recoverStaleBundle } from "./lib/chunkRecovery";
import "./styles.css";
import "./brand-ux.css";
import "./dashboard.css";
import { registerOfflineApp } from "./lib/serviceWorker";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Application root was not found");
}

window.addEventListener("vite:preloadError", (event) => {
  const recovering = recoverStaleBundle(event.payload, {
    storage: window.sessionStorage,
    path: window.location.pathname,
    reload: () => window.location.reload(),
  });
  if (recovering) event.preventDefault();
});

window.setTimeout(() => clearChunkRecovery(window.sessionStorage), 10_000);
registerOfflineApp();

const router = createBrowserRouter([
  {
    path: "*",
    element: (
      <AuthProvider>
        <UnsavedChangesProvider>
          <App />
        </UnsavedChangesProvider>
      </AuthProvider>
    ),
  },
]);

createRoot(root).render(
  <StrictMode>
    <AppErrorBoundary>
      <RouterProvider router={router} />
    </AppErrorBoundary>
  </StrictMode>,
);
